module.exports = __webpack_public_path__ + "img/meth-bags-highlight.e2a2e916.svg";